import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { DeviceStatus } from '@app/models/device-status.interface';
import { AuthService } from '@app/services/auth.service';
import { DeviceStatusHelperService } from '@app/services/helpers/device-status-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faCirclePlus,
  faArrowLeft 
 } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-device-statuses',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './listing.page.html',
    styleUrl: './listing.page.scss'
})
export class DeviceStatusesPage {
  public title = 'Device Statuses';
  deviceStatuses$: Observable<DeviceStatus[]>;

  faCirclePlus = faCirclePlus;
  faArrowLeft = faArrowLeft;

  constructor(
    private deviceStatusHelper: DeviceStatusHelperService,
    public auth: AuthService,
  ) {
    this.deviceStatuses$ = this.deviceStatusHelper.getAll();
  }
}
